import { BreakPoints } from '@kanda-libs/ks-design-library';

import Mobile from './Mobile';
import Desktop from './Desktop';

import { Helmet } from '../../../components';

const ViewComponent = () => (
  <>
    <Helmet title="Verify Email" />
    <BreakPoints mobile={<Mobile />} desktop={<Desktop />} />
  </>
);

ViewComponent.displayName = 'ResetPassword-Confirmation-view';

export default ViewComponent;
